import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hstack gap-2" }
const _hoisted_2 = { class: "mt-1" }
const _hoisted_3 = { class: "mt-1" }
const _hoisted_4 = { class: "mt-1" }
const _hoisted_5 = { class: "mt-1" }

import { computed, ref, watch } from 'vue';
import SelectField from '@/components/Misc/SelectField.vue';
import { SelectEntryType, SelectItem, SelectorMode } from '@/types';
import WebEntrySelectorLayout from '@/components/BSelector/WebEntrySelectorLayout.vue';
import { useOriStore } from '@/stores/oriStore';
import useValidation from '@/components/Misc/validationUtils';
import { handleErrorInResponse } from '@/utils';
import InformationModal from '@/components/Misc/InformationModal.vue';
import { useCommunityPolicingStore } from '@/stores/communityPolicingStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommunityPolicingWebEntry',
  props: {
    title: {},
    url: {},
    allowZeroReport: { type: Boolean },
    allowDeleteReport: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {


const props = __props
const {validatableComponentArray, triggerValidation, addValidatableComponent, resetValidatableComponentArray } = useValidation();

const ori = ref("");
const idInput = ref("");
const year = ref(0);
const years = ref([] as SelectItem[]);
const month = ref(-1);
const months = ref([] as SelectItem[]);
const currentMode = ref({} as SelectEntryType);
const availableModes = ref([] as SelectorMode[]);
const showModal = ref(false);
const validationError = ref("");

if(props.allowZeroReport){
    availableModes.value.push({type:SelectEntryType.Zero, label:'Zero Report', isDefaultSelection: true});
}

if(props.allowDeleteReport){
    availableModes.value.push({type:SelectEntryType.Delete, label:'Delete Report', isDefaultSelection: false});
}

const communityPolicingStore = useCommunityPolicingStore();

const isValid = (mode:SelectEntryType):Boolean => {
    if(mode == SelectEntryType.Zero){
        return year.value > 0 && month.value > 0;
    }
    else if(mode == SelectEntryType.Delete){
        return year.value > 0 && idInput.value != "";
    }         
    
    return true;
}

__expose({ isValid })

function handleOriChange(newOri) {
    communityPolicingStore.setSelectedOri(newOri);
    communityPolicingStore.fetchDatasetDetailsForOri().then(()=> {
        generateYearArray();
    });    
}

function handleModeChange(mode:SelectEntryType){
    
    currentMode.value = mode;
    generateYearArray();
    year.value = 0;
    month.value = -1;
    idInput.value = '';
}

function handleSubmit(ori:any, mode:SelectEntryType) {    
        if(mode == SelectEntryType.Zero) {
            
            communityPolicingStore.submitZeroReport(ori.value, year.value, month.value)
                .then((response) => {
                    window.location.href = 'dataupload.aspx?source=6';
                }).catch(function (error) {
                    handleErrorInResponse(error);
                });
        }
        else if(mode == SelectEntryType.Delete) {
            showModal.value = true;
        }    
}

function submitDelete(){
    let id = idInput.value;
    let ori = communityPolicingStore.getSelectedOri.value;
    let stopYear = year.value;

    communityPolicingStore.validateStopInfo(id,ori,stopYear).then((result) => {    
        if(result && result.data) {
            communityPolicingStore.submitDelete(id,ori,stopYear)
            .then((response) => {
                window.location.href = 'dataupload.aspx?source=6';
            }).catch(function (error) {
                handleErrorInResponse(error);
            });
        }
        else {
            validationError.value = "The record couldn't be located using the information that was provided. Please verify your information and try the request again.";
            showModal.value = false;
        }
    });
}

function generateYearArray() {   
    var data = communityPolicingStore.getDetailsForCurrentDataset;
    
    years.value = [] as SelectItem[];

    if(data != undefined){
        let endDate = data.agency_end_date != undefined ? new Date(data.agency_end_date) : new Date(Date.now());

        //Since we can't submit a zero report for the current month were going to hide the current year is we're still in january otherwise the month drop down is blank.
        if(currentMode.value == SelectEntryType.Zero && endDate.getFullYear() === new Date(Date.now()).getFullYear() && endDate.getMonth() === 0){
            endDate.setFullYear(endDate.getFullYear() -1, 11);
        }

        let startDate = data.agency_start_date != undefined ? new Date(data.agency_start_date) : new Date(data.start_date);

        for(let i = endDate.getFullYear(); i >= startDate.getFullYear(); i--){
            years.value.push(({label:`${i}`, value:i} as SelectItem))
        }

        if(years.value.length > 0){
            year.value = years.value[0].value;
            handleYearUpdate(year.value);
        }
    }    
};

function generateMonthArray() {
    if(year.value === 0){
        return [];
    }

    var data = communityPolicingStore.getDetailsForCurrentDataset;
    months.value = getMonthsAsSelectItemArray();
    
    let endDate = data.agency_end_date != undefined ? new Date(data.agency_end_date) : new Date(Date.now());
    let startDate = data.agency_start_date != undefined ? new Date(data.agency_start_date) : new Date(data.start_date);
    let filtered = months.value;

    if(startDate.getFullYear() == endDate.getFullYear()){
        filtered = months.value.filter((item) => { 
            if(item.value > startDate.getMonth() && item.value <= endDate.getMonth()) 
                return item;
        });
    }
    else{
        if (year.value == endDate.getFullYear()) {
            filtered = months.value.filter((item) => 
            {
                if(item.value <= endDate.getMonth())
                    return item;
            });
        }
        else if(year.value == startDate.getFullYear()){
            filtered = months.value.filter((item) => 
            {
                if(item.value > startDate.getMonth()) 
                    return item;
            
            });
        }
        else {
            filtered = months.value;
        }
    }
        
    months.value = filtered.sort((n1,n2) => {
            if (n1.value < n2.value) {
                return 1;
            }
            if (n1.value > n2.value) {
                return -1;
            }
            return 0;
        });

};

function getMonthsAsSelectItemArray(){
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ] as const;
      
    let monthsArray = [] as SelectItem[];
    
    monthNames.map((value, index) => {
        monthsArray.push({label: value, value: index + 1} as SelectItem);
    });
    
    return monthsArray;
}

function handleYearUpdate(newYear){
    generateMonthArray();
}

function handleModalDismiss(){
    showModal.value = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WebEntrySelectorLayout, {
    title: _ctx.title,
    "show-nav": availableModes.value.length > 1,
    modes: availableModes.value,
    error: validationError.value,
    agencies: _unref(communityPolicingStore).getOrisForSelectList,
    onOriChange: handleOriChange,
    onModeChange: handleModeChange,
    onSubmit: handleSubmit
  }, {
    "extra-fields-delete": _withCtx(() => [
      _createVNode(InformationModal, {
        title: "Delete Confirmation",
        "show-footer": true,
        "show-modal": showModal.value,
        onDismiss: handleModalDismiss
      }, {
        body: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode(" Are you sure you want to delete this stop? ", -1)
        ])),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary w-50",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (submitDelete()), ["prevent"]))
            }, "Ok"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary w-50",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleModalDismiss()), ["prevent"]))
            }, "Cancel")
          ])
        ]),
        _: 1
      }, 8, ["show-modal"]),
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label mb-1 fw-bolder" }, "Year:", -1)),
        _createVNode(SelectField, {
          modelValue: year.value,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((year).value = $event)),
            _cache[3] || (_cache[3] = ($event: any) => (handleYearUpdate($event)))
          ],
          "select-items": years.value,
          "is-horizontal": false,
          "is-required": true,
          ref: (el) => { _unref(addValidatableComponent)(el) }
        }, null, 8, ["modelValue", "select-items"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label mb-1 fw-bolder" }, "Stop Number:", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control form-text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((idInput).value = $event)),
          required: true,
          "aria-required": "true"
        }, null, 512), [
          [_vModelText, idInput.value]
        ])
      ])
    ]),
    "extra-fields-zero": _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label mb-1 fw-bolder" }, "Year:", -1)),
        _createVNode(SelectField, {
          modelValue: year.value,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => ((year).value = $event)),
            _cache[6] || (_cache[6] = ($event: any) => (handleYearUpdate($event)))
          ],
          "select-items": years.value,
          "is-horizontal": false,
          "is-required": true,
          ref: (el) => { _unref(addValidatableComponent)(el) }
        }, null, 8, ["modelValue", "select-items"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label mb-1 fw-bolder" }, "Month:", -1)),
        _createVNode(SelectField, {
          modelValue: month.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((month).value = $event)),
          "select-items": months.value,
          "is-horizontal": false,
          "is-required": true
        }, null, 8, ["modelValue", "select-items"])
      ])
    ]),
    _: 1
  }, 8, ["title", "show-nav", "modes", "error", "agencies"]))
}
}

})